import { render, staticRenderFns } from "./UserAnalysis.vue?vue&type=template&id=97bd53ae&scoped=true"
import script from "./UserAnalysis.vue?vue&type=script&lang=js"
export * from "./UserAnalysis.vue?vue&type=script&lang=js"
import style0 from "./UserAnalysis.vue?vue&type=style&index=0&id=97bd53ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bd53ae",
  null
  
)

export default component.exports